import request from "../../Request";
import {rThen} from "../../requestThen";

export let deleteChildren = async (relUserId) => {

    return request.delete(`/api/base_user/remove_acc/${relUserId}`,).then(r => {
        return rThen(r);
    })
}